<!-- Payment Card: Front -->
<div
  class="payment-card"
  [ngClass]="{
    'active-card bg-active-card': cardIsActive(),
    'inactive-card bg-inactive-card': cardIsInactive(),
    'frozen-card bg-frozen-card': cardIsFrozen(),
    'card-issuer-bg': cardToken.CardIssuer == cardIssuerProvider,
  }"
>
  <div class="d-flex flex-row align-items-center justify-content-between">
    <div class="d-flex flex-column">
      <p *ngIf="cardIsActive()" class="card-status font-size-12 active fw-bold">{{ 'payment.card.active' | translate }}</p>
      <p *ngIf="cardIsInactive()" class="card-status font-size-12 inactive fw-bold">
        {{ 'payment.card.inactive' | translate }}
      </p>
      <p *ngIf="cardIsFrozen()" class="card-status font-size-12 frozen fw-bold">{{ 'payment.card.frozen' | translate }}</p>
      <p *ngIf="isPaze()" class="paze-label font-size-10 fst-italic text-white mb-0" style="padding-left: 10px; padding-top: 6px">
        {{ 'payment.card.saved.with.paze' | translate: { fgbdefault: 'Saved with Paze' } }}
      </p>
    </div>
    <div ngbDropdown placement="bottom-start" class="switch-card-dropdown d-inline-block" *ngIf="!showExpiry || !cardIsExpire()">
      <button class="btn-settings switch-side cog" id="switchCardDropdown" ngbDropdownToggle (click)="switchCardSide()">
        <span class="icon material-icons" [ngClass]="cardIsInactive() ? 'text-black' : 'text-white'">more_horiz</span>
      </button>

      <div ngbDropdownMenu aria-labelledby="switchCardDropdown" class="payment-card card-dropdown back align-items-center">
        <button
          *ngIf="cardIsActive()"
          class="btn-status w-80 freeze w-100"
          confirmModal
          modal-class="card-token-modal"
          [confirmContent]="freeze"
          [confirmHeader]="{ data: ('card.status.freeze' | translate) }"
          (confirm)="freezeCard()"
        >
          <label class="card-status freeze-color justify-content-start cursor-pointer fw-normal">
            <span class="material-icons fw-bold freeze-color font-size-18 me-2" aria-hidden="true">ac_unit</span>
            <span class="font-size-14 text-capitalize">{{ 'payment.card.freeze.label' | translate }}</span>
          </label>
        </button>
        <button
          *ngIf="cardIsInactive()"
          class="btn-status w-80 activate"
          confirmModal
          modal-class="card-token-modal"
          [confirmContent]="activate"
          [confirmHeader]="{ data: ('card.status.activate' | translate) }"
          (confirm)="setCardAsDefault()"
        >
          <label class="card-status text-success justify-content-start cursor-pointer fw-normal">
            <span class="material-icons text-success font-size-18 me-2 fw-bold"> check_circle </span>
            <span class="font-size-14 text-capitalize">{{ 'payment.card.activate.label' | translate }}</span>
          </label>
        </button>
        <button
          *ngIf="cardIsFrozen()"
          class="btn-status w-80 unfreeze w-100"
          confirmModal
          modal-class="card-token-modal"
          [confirmContent]="unfreeze"
          [confirmHeader]="{ data: ('card.status.unfreeze' | translate) }"
          (confirm)="unfreezeCard()"
        >
          <label class="card-status justify-content-start text-success cursor-pointer fw-normal">
            <span class="material-icons text-success font-size-18 me-2 fw-bold"> check_circle </span>
            <span class="font-size-14 text-capitalize">{{ 'payment.card.unfreeze.label' | translate }}</span>
          </label>
        </button>

        <button
          class="btn d-flex delete mb-3"
          confirmModal
          modal-class="card-token-modal"
          [confirmContent]="delete"
          [confirmHeader]="{ data: ('card.status.delete' | translate) }"
          (confirm)="deleteCard()"
        >
          <span class="material-icons fw-bold text-danger font-size-18 me-2" aria-hidden="true">delete_forever</span>
          <label class="text-danger fw-normal font-size-14 mb-0 cursor-pointer">{{
            'payment.card.delete.label' | translate
          }}</label>
        </button>
      </div>
    </div>
    @if (showExpiry) {
      <div *ngIf="cardIsExpire()">
        <button
          class="btn d-flex align-items-center expired-card-delete"
          [ngClass]="cardIsInactive() ? 'text-black' : 'text-white'"
          confirmModal
          modal-class="card-token-modal"
          [confirmContent]="delete"
          [confirmHeader]="{ data: ('card.status.delete' | translate) }"
          (confirm)="deleteCard()"
        >
          <span class="material-icons fw-bold font-size-16 me-1" aria-hidden="true">delete_forever</span>
          <label class="fw-normal font-size-12 mb-0 cursor-pointer">{{ 'payment.expired.card.delete.label' | translate }}</label>
        </button>
      </div>
    }
  </div>
  @if (showExpiry) {
    <div *ngIf="cardIsExpire()" class="expired-card-div d-flex align-items-center justify-content-center mt-2 mx-2">
      <span class="expired-card">{{ 'payment.card.expired.label' | translate }}</span>
    </div>
  }
  <div class="d-flex flex-row align-items-end justify-content-between mb-2 mx-2 mt-0">
    <p class="mb-0 ms-1 font-size-12" [ngClass]="cardIsInactive() ? 'text-black' : 'text-white'">
      ({{ cardToken.CardNumber.substring(12) }})
    </p>
    @if (showExpiry) {
      @if (noExpiry && !isPaze()) {
        <img
          alt=""
          class="card-provider-image card-provider-{{ cardToken.ProviderId }}"
          src="{{ 'providers/' + cardToken.ProviderId + '.svg' | contentAssetImage }}"
        />
      } @else {
        <p class="mb-0 ms-1 font-size-12" [ngClass]="cardIsInactive() ? 'text-black' : 'text-white'">
          {{ 'payment.card.expiry.date' | translate }} {{ cardToken.ExpiryDate | date: 'MM/YY' }}
        </p>
      }
    }
    <!--Hide icon if a certain provider is passed in or if provider is PayPal-->
    <ng-container *ngIf="cardToken.CardIssuer != cardIssuerProvider && !isPayPal()">
      <ng-container [ngSwitch]="cardToken.CardType">
        <img *ngSwitchCase="1" alt="" class="card-type-image" [src]="'payment-icons/mastercard.svg' | contentAssetImage" />
        <img *ngSwitchCase="2" alt="" class="card-type-image" [src]="'payment-icons/amex.svg' | contentAssetImage" />
        <img *ngSwitchCase="3" alt="" class="card-type-image" [src]="'payment-icons/visa.svg' | contentAssetImage" />
        <img *ngSwitchCase="4" alt="" class="card-type-image" [src]="'payment-icons/discover.svg' | contentAssetImage" />
        <img *ngSwitchCase="5" alt="" class="card-type-image" [src]="'payment-icons/jcb.svg' | contentAssetImage" />
        <img *ngSwitchCase="8" alt="" class="card-type-image" [src]="'payment-icons/unionpay.svg' | contentAssetImage" />
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #freeze>
  <div class="my-2">
    {{ 'payment.card.freeze.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}
  </div>
</ng-template>

<ng-template #unfreeze>
  <div class="my-2">
    {{ 'payment.card.unfreeze.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}
  </div>
</ng-template>

<ng-template #delete>
  <div class="my-2">
    {{ 'payment.card.delete.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}
  </div>
</ng-template>

<ng-template #activate>
  <div class="my-2">
    {{ 'payment.card.activation.confirmation' | translate: { cardEnding: cardToken.CardNumber.substring(12) } }}
  </div>
</ng-template>
